module.exports = __webpack_public_path__ + "media/images/pc/banner/hokepon_reserve_side-ee893a9c805846ff92bb8f30231720e2.png";